import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

// Packages
import { Col, Row, Select, Typography } from 'antd';
import PropTypes from 'prop-types';

// Actions
import { get_organizations, get_workspaces, set_org_filters } from '../../actions/organizationActions';

const OrgFilters = (props) => {
	const { orgFilters, setOrgFilters, displayFilters } = props;

	const dispatch = useDispatch();

	const { user } = useSelector(state => state.auth);

	const { global_data } = useSelector(state => state.global);

	const { organizations, workspaces } = useSelector(state => state.organization);

	useEffect(() => {
		dispatch(get_organizations());
	}, []);

	useEffect(() => {
		let _organization = '';

		if (organizations.length <= 1) {
			_organization = user.organization;
		}
		else {
			_organization = localStorage.getItem('organization') || '';
		}

		const _orgFilters = {
			...orgFilters,
			organization: _organization,
			workspace: localStorage.getItem('workspace') || ''
		}
		
		setOrgFilters(_orgFilters);
		dispatch(set_org_filters(_orgFilters));
	}, [organizations]);

	useEffect(() => {
		if (orgFilters.organization !== '') {
			dispatch(get_workspaces({ organization: orgFilters.organization }));
		}
	}, [orgFilters]);

	const onChangeOrgFilters = (e, name) => {
		let filters = {...orgFilters};
		let keys = Object.keys(filters);
		
		if (e === null || e === undefined) {
			let idx = keys.indexOf(name);
			for (let index = idx; index < keys.length; index++) {
				const key = keys[index];
				filters[key] = '';
				localStorage.setItem(key, '');
			}
		}
		else {
			filters[name] = e.value;
			localStorage.setItem(name, e.value);
		}

		setOrgFilters(filters);
		dispatch(set_org_filters(filters));
	}

	return (
		<Row justify='center' gutter={[16, 16]}>
			{displayFilters?.organization &&
				organizations.length > 1 &&
					<Col className='gutter-row' style={{ zIndex: 10 }} lg={6} md={8} sm={24} xs={24}>
						<Row justify='center'>
							<Typography.Text><i className='bi bi-house' style={{ marginRight: '0.5rem' }}></i>{global_data?.organizationTerms?.organization}</Typography.Text>
						</Row>
						<Select
							style={{ width: '100%' }}
							options={organizations.map(option => ({ value: option._id.$oid, label: option.name }))}
							value={organizations.find(option => option._id.$oid === orgFilters.organization)?.name}
							onChange={(value, option) => onChangeOrgFilters(option, 'organization')}
							disabled={false}
							allowClear={true}
							showSearch
							filterOption={(input, option) => (option?.label?.toLowerCase() ?? '').includes(input?.toLowerCase())}
						/>
					</Col>
				
			}
			{displayFilters?.workspace &&
				<Col className='gutter-row' style={{ zIndex: 10 }} lg={6} md={8} sm={24} xs={24}>
					<Row justify='center'>
						<Typography.Text><i className='bi bi-list' style={{ marginRight: '0.5rem' }}></i>{global_data?.organizationTerms?.workspace}</Typography.Text>
					</Row>
					<Select
						style={{ width: '100%' }}
						options={workspaces.map(option => ({ value: option._id.$oid, label: option.name }))}
						value={workspaces.find(option => option._id.$oid === orgFilters.workspace)?.name}
						onChange={(value, option) => onChangeOrgFilters(option, 'workspace')}
						disabled={false}
						allowClear={true}
						showSearch
						filterOption={(input, option) => (option?.label?.toLowerCase() ?? '').includes(input?.toLowerCase())}
					/>
				</Col>
			}
		</Row>
	);
}

OrgFilters.propTypes = {
	orgFilters: PropTypes.object.isRequired,
	setOrgFilters: PropTypes.func.isRequired,
	displayFilters: PropTypes.object.isRequired
};

export default OrgFilters;